<template>
  <div>
    <div v-if="!loading">
      <TextFormGroup
          :value="value.ad_unit_id"
          name="ad_unit_id"
          label="Ad Unit ID"
          :error="(errors.ad_unit_id || [])[0]"
          help-text="The ad will only be displayed on editorial articles."
          @input="emit('ad_unit_id', $event)"
      />

      <TextFormGroup
          :value="value.keyword"
          name="keyword"
          label="Keyword"
          :error="(errors.keyword || [])[0]"
          help-text="The ad will only be displayed on editorial articles."
          @input="emit('keyword', $event)"
      />

      <RepeatableFormGroup
          label="Content Article Flags"
          :value="value.content_article_flags"
          :errors="contentArticleFlagErrors"
          help-text="Select the flags that the block should display as promoted items. The latest article with each flag will be shown."
          @input="emit('content_article_flags', $event)"
      >
        <template v-slot:default="{ data, index, change, errors }">
          <SelectFormGroup
              :value="data.id"
              name="content_article_flag_id"
              :label="'Flag #' + (index + 1)"
              :error="(errors.id || [])[0]"
              :options="contentArticleFlagOptions"
              :nullable="true"
              @input="change(index, 'id', $event)"
          />
        </template>
      </RepeatableFormGroup>

    </div>
  </div>
</template>

<script>
import http from '@/http'
import store from '@/store'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'
import RepeatableFormGroup from "../../../Forms/RepeatableFormGroup.vue";

export default {
  components: {RepeatableFormGroup, SelectFormGroup, TextFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    },

    portal: {
      required: true
    }
  },

  data() {
    return {
      contentArticleFlags: null,

      shared: store,
      loading: true
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    contentArticleFlagOptions() {
      return this.contentArticleFlags.map(contentArticleFlag => {
        return {
          value: contentArticleFlag.id,
          label: contentArticleFlag.attributes.name
        }
      })
    },

    contentArticleFlagErrors() {
      return Object.entries(this.errors)
          .filter(entry => entry[0].startsWith('content_article_flags.'))
          .reduce((result, entry) => ({
            ...result,
            [entry[0].substring('content_article_flags.'.length)]: entry[1]
          }), {})
    }
  },

  methods: {
    load() {
      http.get('/api/v2/content-article-flags', {'filter[portal_id]': this.portal.id})
          .then(response => {
            this.contentArticleFlags = response.data.data

            this.loading = false
          })
    },

    emit(key, value) {
      this.$emit('input', {...this.value, [key]: value})
    }
  }
}
</script>
